export default function getItemStyles(props) {
  const {
    currentNodeHover,
    initialOffset,
    item,
    currentOffset,
    clientOffset
  } = props
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    }
  }

  let { x, y } = clientOffset
  let overCoord = null
  let prevent = false
  // tree-node-links fires signal if we are at a new node.
  if (currentNodeHover) {
    if (currentNodeHover.top + 6 >= y) {
      overCoord = currentNodeHover.top - 1
    }

    if (currentNodeHover.bottom - 6 <= y) {
      overCoord = currentNodeHover.bottom - 1
    }
    if (currentNodeHover.level > item.level) {
      // prevent parent node to be drag in child node
      if (currentNodeHover.path.startsWith(item.path)) {
        prevent = true
      }
    }
    // prevent drag to same path
    if (currentNodeHover.path === item.path) {
      prevent = true
    }
  }

  if (overCoord && !prevent) {
    return {
      position: 'fixed',
      height: 0,
      backgroundColor: '#fff',
      borderTop: '1px dashed #72ccb3',
      top: overCoord,
      left: 0,
      width: 250
    }
  }

  return {
    position: 'fixed',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: 23,
    height: 23,
    background: prevent ? 'red' : '#72ccb3',
    borderRadius: '50%',
    top: y + 10,
    left: x + 10,
    display: 'block',
    pointerEvents: 'none',
    boxShadow: '0 3px 6px rgba(0, 0, 0, .175)'
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/NodeDragLayer/getItemStyles.js